<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Nehmen die Schmerzen bei Stress zu?</p>
</QuestionFrame>
